import { render, staticRenderFns } from "./ImportAttachment.vue?vue&type=template&id=fc5cc176&"
import script from "./ImportAttachment.vue?vue&type=script&lang=js&"
export * from "./ImportAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports